export enum GeneratedBy {
  INTERNAL = 'INTERNAL',
  ExternalInvoice4U = 'EXTERNAL-INVOICE4U',
}
